module.exports = __webpack_public_path__ + "img/card_proposalrequest_contract.586dd222.svg";